/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * 
 * @export
 * @interface CheckIfAddressIsResidentialRequest
 */
export interface CheckIfAddressIsResidentialRequest {
    /**
     * 
     * @type {Address}
     * @memberof CheckIfAddressIsResidentialRequest
     */
    address: Address;
}

/**
 * Check if a given object implements the CheckIfAddressIsResidentialRequest interface.
 */
export function instanceOfCheckIfAddressIsResidentialRequest(value: object): value is CheckIfAddressIsResidentialRequest {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CheckIfAddressIsResidentialRequestFromJSON(json: any): CheckIfAddressIsResidentialRequest {
    return CheckIfAddressIsResidentialRequestFromJSONTyped(json, false);
}

export function CheckIfAddressIsResidentialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckIfAddressIsResidentialRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': AddressFromJSON(json['address']),
    };
}

  export function CheckIfAddressIsResidentialRequestToJSON(json: any): CheckIfAddressIsResidentialRequest {
      return CheckIfAddressIsResidentialRequestToJSONTyped(json, false);
  }

  export function CheckIfAddressIsResidentialRequestToJSONTyped(value?: CheckIfAddressIsResidentialRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': AddressToJSON(value['address']),
    };
}

